import {
  CreateRequestDto,
  GetRequestDto,
  MessageResponseDto,
  PersonControllerActivity200Response,
  RequestApiFp,
  RequestControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseRequestModel = RequestControllerGet200Response;
export type GetActivityResponseRequestModel =
  PersonControllerActivity200Response;

export type GetRequestModel = GetRequestDto;
export type MutateResponseRequestModel = MessageResponseDto;
export type CreateRequestModel = CreateRequestDto;

export const apiRequestFp = RequestApiFp(apiConfig);
export const getRequestController = apiRequestFp.requestControllerGet;
export const getActivityRequestController =
  apiRequestFp.requestControllerActivity;
export const createRequestController = apiRequestFp.requestControllerCreate;

export const QueryKeyRequest = QueryKey.Request;
export type RequestCreateData = {
  tenant: string;
  user_code: string;
  card_series: string;
  campaign: string;
  code: string;
  status: "PENDING" | "ACTIVE" | "EXPIRED" | string; // Adjust enum as needed
  expiration: string; // ISO date string, consider using `Date` if parsed
  created_at: string;
  created_by: string;
  updated_at: string;
  updated_by: string;
  deleted_at: string | null;
  deleted_by: string | null;
  is_active: boolean;
  id: number;
};
